export const categoryLinks = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", imageSeq: "cat-shoes-01" },
  { name: "Hoodies / Sweaters", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html", imageSeq: "cat-hoodies-02" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html", imageSeq: "cat-tshirts-03" },
  { name: "Jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html", imageSeq: "cat-jackets-04" },
  { name: "Pants / Shorts", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html", imageSeq: "cat-pants-05" },
  { name: "Headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html", imageSeq: "cat-headwear-06" },
  { name: "Sets", url: "https://kaspreadsheet.com/category-917-Sets.html", imageSeq: "cat-sets-07" },
  { name: "Underwear / Underpants", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html", imageSeq: "cat-underwear-08" },
  { name: "Jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html", imageSeq: "cat-jersey-09" },
  { name: "Accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html", imageSeq: "cat-accessories-10" },
  { name: "Bags", url: "https://kaspreadsheet.com/category-921-Bags.html", imageSeq: "cat-bags-11" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Bags.html", imageSeq: "cat-belts-12" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Bags.html", imageSeq: "cat-perfumes-13" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Bags.html", imageSeq: "cat-other-14" },
];

export const popularCategories = [
  { name: "Shoes", description: "Sneakers, boots & more", itemCount: "2,400+ items", url: "https://kaspreadsheet.com/category-911-Shoes.html", imageSeq: "pop-shoes-01" },
  { name: "Hoodies", description: "Sweaters & pullovers", itemCount: "1,800+ items", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html", imageSeq: "pop-hoodies-02" },
  { name: "T-Shirts", description: "Graphic & plain tees", itemCount: "3,200+ items", url: "https://kaspreadsheet.com/category-913-T-Shirts.html", imageSeq: "pop-tshirts-03" },
  { name: "Jackets", description: "Coats & outerwear", itemCount: "1,500+ items", url: "https://kaspreadsheet.com/category-914-Jackets.html", imageSeq: "pop-jackets-04" },
  { name: "Pants", description: "Shorts & trousers", itemCount: "2,100+ items", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html", imageSeq: "pop-pants-05" },
  { name: "Headwear", description: "Caps & beanies", itemCount: "900+ items", url: "https://kaspreadsheet.com/category-916-Headwear.html", imageSeq: "pop-headwear-06" },
  { name: "Sets", description: "Matching outfits", itemCount: "600+ items", url: "https://kaspreadsheet.com/category-917-Sets.html", imageSeq: "pop-sets-07" },
  { name: "Bags", description: "Backpacks & handbags", itemCount: "1,200+ items", url: "https://kaspreadsheet.com/category-921-Bags.html", imageSeq: "pop-bags-08" },
];

export const blogArticles = [
  {
    title: "What Is a Kakobuy Spreadsheet and How to Use It in 2026",
    excerpt: "A complete beginner's guide to understanding and maximizing your Kakobuy spreadsheet for smarter shopping.",
    slug: "/guide",
    imageSeq: "blog-guide-01",
  },
  {
    title: "Kakobuy Spreadsheet Shipping Guide: Save Money & Avoid Delays",
    excerpt: "Learn shipping strategies, carrier comparisons, and money-saving tips for your Kakobuy orders.",
    slug: "/guide/shipping-tips",
    imageSeq: "blog-ship-02",
  },
  {
    title: "Complete Kakobuy QC Spreadsheet Checklist for Quality Shopping",
    excerpt: "Master the quality control process with our comprehensive checklist to ensure you get exactly what you ordered.",
    slug: "/guide/qc-checklist",
    imageSeq: "blog-qc-03",
  },
  {
    title: "Top 10 Trusted Kakobuy Sellers in Our Spreadsheet 2026",
    excerpt: "Discover the most reliable and highly-rated Kakobuy sellers our community trusts for consistent quality.",
    slug: "/guide/best-sellers",
    imageSeq: "blog-sellers-04",
  },
  {
    title: "Best Kakobuy Spreadsheet Shoe Finds: Sneakers & Footwear Guide",
    excerpt: "Explore the hottest sneaker and footwear listings from our Kakobuy spreadsheet with verified QC photos.",
    slug: "/guide/shoe-finds",
    imageSeq: "blog-shoes-05",
  },
  {
    title: "Kakobuy Spreadsheet Hoodie Guide: Find the Best Quality Sweaters",
    excerpt: "Your ultimate resource for finding premium hoodies and sweaters through our curated spreadsheet listings.",
    slug: "/guide/hoodie-guide",
    imageSeq: "blog-hoodie-06",
  },
  {
    title: "Top Kakobuy Spreadsheet Bag Collection: Designer & Casual",
    excerpt: "Browse our handpicked bag collection featuring everything from luxury handbags to everyday backpacks.",
    slug: "/guide/bag-collection",
    imageSeq: "blog-bags-07",
  },
  {
    title: "Kakobuy Spreadsheet for Beginners: 10 Essential Tips to Start",
    excerpt: "New to Kakobuy? These ten essential beginner tips will help you navigate the platform with confidence.",
    slug: "/guide/beginner-tips",
    imageSeq: "blog-beginner-08",
  },
  {
    title: "Kakobuy Safety Guide: How to Avoid Scams Using Our Spreadsheet",
    excerpt: "Protect yourself from common Kakobuy scams with our comprehensive safety guide and red flag checklist.",
    slug: "/guide/safety-guide",
    imageSeq: "blog-safety-09",
  },
  {
    title: "Kakobuy Spreadsheet Sizing Guide: Never Order the Wrong Size",
    excerpt: "Master Kakobuy sizing with our detailed measurement guide covering international size conversions and fit tips.",
    slug: "/guide/sizing-guide",
    imageSeq: "blog-sizing-10",
  },
];

export const reviews = [
  {
    name: "Marcus Thompson",
    handle: "@marcust_finds",
    avatar: "MT",
    content: "I have been using the Kakobuy Spreadsheet for over six months now and it has completely transformed how I shop. The verified seller lists alone have saved me hundreds of dollars and countless hours of research. Every purchase I have made through the spreadsheet recommendations has been spot on.",
  },
  {
    name: "Elena Rodriguez",
    handle: "@elenashopdiary",
    avatar: "ER",
    content: "Honestly the best Kakobuy spreadsheet resource out there. The weekly updates mean I am always finding fresh pieces before they blow up. The QC guides are a game-changer for checking quality before buying.",
  },
  {
    name: "James Chen",
    handle: "@jchenstyle",
    avatar: "JC",
    content: "Was skeptical at first but this Kakobuy Spreadsheet is legit. Found some amazing sneakers that I could not track down anywhere else. The seller trust ratings really help filter out the noise.",
  },
  {
    name: "Sophie Laurent",
    handle: "@sophielaurent_",
    avatar: "SL",
    content: "As someone new to Kakobuy, this spreadsheet made everything so much easier. The category breakdowns are intuitive, the links always work, and the community feedback on each item is invaluable. Cannot recommend it enough.",
  },
  {
    name: "David Park",
    handle: "@dpark_reviews",
    avatar: "DP",
    content: "What sets this Kakobuy Spreadsheet apart is the attention to detail. Every product entry has actual QC photos, sizing notes, and seller history. It is basically a curated shopping assistant in spreadsheet form.",
  },
  {
    name: "Olivia Wright",
    handle: "@oliviawfinds",
    avatar: "OW",
    content: "The Kakobuy Spreadsheet has become my go-to before any purchase. The safety guides alone are worth bookmarking. Shipping tips section helped me avoid so many common pitfalls. Truly a must-have resource.",
  },
];

export const faqItems = [
  {
    question: "What is a Kakobuy Spreadsheet?",
    answer: "A Kakobuy Spreadsheet is a curated, regularly updated resource that lists verified product finds, trusted sellers, quality control information, and shopping guides for the Kakobuy platform. It helps shoppers discover reliable products and avoid common pitfalls when purchasing through Kakobuy.",
  },
  {
    question: "How often is the Kakobuy Spreadsheet updated?",
    answer: "Our Kakobuy Spreadsheet is updated on a weekly basis. We continuously add new verified product finds, review seller reputations, and refresh buying guides to ensure you always have access to the most current and reliable information.",
  },
  {
    question: "Are the sellers in the spreadsheet verified?",
    answer: "Yes. Every seller listed in our Kakobuy Spreadsheet undergoes a verification process that includes checking seller history, buyer feedback, response rates, and product quality consistency. We only include sellers who meet our trust standards.",
  },
  {
    question: "How do I use the Kakobuy Spreadsheet to find products?",
    answer: "Simply browse by category using our navigation dropdown or category cards. Each entry links directly to the product or seller page on Kakobuy. You can explore categories like Shoes, Hoodies, T-Shirts, Jackets, Bags, and more to find exactly what you are looking for.",
  },
  {
    question: "Is the Kakobuy Spreadsheet free to use?",
    answer: "Absolutely. Our Kakobuy Spreadsheet is completely free to access. We believe in making trusted shopping resources available to everyone in the community without any paywalls or subscription requirements.",
  },
];